export default "__VITE_ASSET__c2efa431__"